import { App, Button } from 'antd';
import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { schedulePeriodicUpdate } from './pwaUpdate';

const NOTIFICATION_KEY = 'pwa-update';

/** Mounted once near the app root, inside `AntdProvider`'s `<App>` — offers a reload when the
 *  service worker has fetched a new version (`registerType: 'autoUpdate'` in vite.config.ts still
 *  needs the user to reload to actually run it). Renders nothing itself; the prompt is an antd
 *  notification. */
export function PwaUpdatePrompt() {
  const { notification } = App.useApp();
  // Вкладка может стоять открытой днями — новую версию она сама не заметит (см. schedulePeriodicUpdate).
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (registration) schedulePeriodicUpdate(registration);
    },
  });
  const [needsRefresh] = needRefresh;

  useEffect(() => {
    if (!needsRefresh) return;
    notification.info({
      key: NOTIFICATION_KEY,
      message: 'Доступно обновление',
      btn: (
        <Button type="primary" size="small" onClick={() => void updateServiceWorker(true)}>
          Обновить
        </Button>
      ),
      duration: 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needsRefresh]);

  return null;
}
